<template>  
    <div class="flex-row">
      <el-tooltip placement="top" content="検索開始日">
        <el-date-picker
          v-model="searchPeriodFrom"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 100%; max-width: 120px; margin-right: 5px;"
          @change="searchPostPeriodChange"
          :picker-options="fromPickerOptions"
        ></el-date-picker>
      </el-tooltip>
      <p>〜</p>
      <el-tooltip placement="top" content="検索終了日">
        <el-date-picker
          v-model="searchPeriodTo"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 100%; max-width: 120px; margin-left: 5px; margin-right: 10px;"
          @change="searchPostPeriodChange"
          :picker-options="toPickerOptions"        
        ></el-date-picker>
      </el-tooltip>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      searchGraphPostPeriod: {
        type: Array,
        required: false,
      },
    },
    data() {
      return {
        post_date: [],
        searchPeriodFrom: "",
        searchPeriodTo: "",
        fromPickerOptions: {
          disabledDate: this.disableAfterToDate,
        },
        toPickerOptions: {
          disabledDate: this.disableBeforeFromDate,
        },
      };
    },
    methods: {
      searchPostPeriodChange() {
        this.$emit("date-change", this.searchPeriodFrom, this.searchPeriodTo);
      },
      disableAfterToDate(time) {
        if (this.searchPeriodTo) {
          return new Date(this.searchPeriodTo) < time.getTime();
        }
        return false;
      },
      disableBeforeFromDate(time) {
        if (this.searchPeriodFrom) {
          return new Date(this.searchPeriodFrom) > time.getTime();
        }
        return false;
      },
    },
    watch: {
      searchGraphPostPeriod() {
        this.searchPeriodFrom = this.searchGraphPostPeriod[0];
        this.searchPeriodTo = this.searchGraphPostPeriod[1];
      }
    },
  };
  </script>